import React, { useEffect } from 'react';

import { useInstoreEnrollmentAnalytics } from '../hooks/use-instore-enrollment-analytics';
import { useMedIntake } from './use-med-intake';
import { GetStartedStep } from './get-started-step';
import { PersonalInformationStep } from './personal-information-step';
import { AddressStep } from './address-step';
import { GoodCannaStep } from './good-canna-step';
import { MedIntakeContainer } from './med-intake-ui';
import { WaitingStep } from './waiting-step';
import { SubmittedStep } from './submitted-step';

export const MedIntake = (): JSX.Element => {
  const {
    step,
    formData,
    isSubmitting,
    submissionError,
    submissionSuccess,
    nextStep,
    previousStep,
    handleStepSubmit,
    handleFinalSubmit,
  } = useMedIntake();
  const { trackStepViewed } = useInstoreEnrollmentAnalytics();

  // Track step viewed on mount
  useEffect(() => {
    trackStepViewed('medIntake');
  }, [trackStepViewed]);

  return (
    <MedIntakeContainer data-testid='med-intake-container'>
      {step === 0 && <GetStartedStep onNext={nextStep} />}
      {step === 1 && (
        <PersonalInformationStep
          onNext={handleStepSubmit}
          onBack={previousStep}
          defaultValues={formData.personalInfo}
        />
      )}
      {step === 2 && <AddressStep onNext={handleStepSubmit} onBack={previousStep} defaultValues={formData.address} />}
      {step === 3 && (
        <GoodCannaStep onNext={handleStepSubmit} onBack={previousStep} defaultValues={formData.goodCanna} />
      )}
      {step === 4 && <WaitingStep onNext={handleFinalSubmit} onBack={previousStep} />}
      {step === 5 && (
        <SubmittedStep
          isSubmitting={isSubmitting}
          submissionError={submissionError}
          submissionSuccess={submissionSuccess}
        />
      )}
    </MedIntakeContainer>
  );
};
